import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const FIELDS_URL = `${SERVER_API}/fields`;

export const FIELD_ENDPOINTS = {
  TYPES: {
    method: 'GET',
    url: `${FIELDS_URL}/types`,
  } as IEndpointData,
  TYPES_GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${FIELDS_URL}/types/${id.toString()}`,
    };
  },
  LIST: {
    method: 'GET',
    url: `${FIELDS_URL}`,
  } as IEndpointData,
  CREATE: {
    method: 'POST',
    url: `${FIELDS_URL}`,
  } as IEndpointData,
  UPDATE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${FIELDS_URL}/${id.toString()}`,
    };
  },
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${FIELDS_URL}/${id.toString()}`,
    };
  },
  DELETE(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${FIELDS_URL}/${id.toString()}`,
    };
  },
  SEND_CHECK(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${FIELDS_URL}/${id.toString()}/check`,
    };
  },
  CHANGE_STATUS(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${FIELDS_URL}/${id.toString()}/change-status`,
    };
  },
};
